"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Panel = (0, _styles.withStyles)(() => ({
  root: {
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)'
  }
}))(({
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_core.Paper, props, children));
var _default = Panel;
exports.default = _default;